export { SharedModule } from './shared.module';
export { BasePhotoWrapperComponent, BasePhotoModule } from './base-photo';
